var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/components/Addon/index.js",
  _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { createURL } from '@sm/utils';
import { T, defineMessages } from '@sm/intl';
import { generateMetricsAttribute } from '@sm/metrics';
import { TabletScreen } from '../../../MediaComponents';
import LogInCTA from '../LogInCTA';
import SignUpCTA from '../SignUpCTA';
import SMHeaderContext from '../../SMHeaderContext';
import SeatUpgradeButton from './SeatUpgradeButton';
import './addon.scss';
import JoinTeamCTA from '../JoinTeamCTA';
export var COPY = defineMessages({
  UPGRADE: {
    id: 'Addon.upgradeButton',
    defaultMessage: 'UPGRADE',
    description: '[Type: Label][Vis.: high] - This is the upgrade addon button on the header.'
  },
  CREATE_SURVEY: {
    id: 'Addon.createSurvey',
    defaultMessage: 'CREATE SURVEY',
    description: '[Type: Label][Vis.: high] - This is the create survey addon button on the header.'
  },
  CREATE_TEAM: {
    id: 'Addon.createTeam',
    defaultMessage: 'CREATE TEAM',
    description: '[Type: Label][Vis.: high] - This is the create team addon button on the header.'
  },
  ADD_USERS: {
    id: 'Addon.addUsers',
    defaultMessage: 'ADD USERS',
    description: '[Type: Label][Vis.: high] - This is the add users addon button on the header.'
  }
});
export var UpgradeButton = function UpgradeButton() {
  var smHeaderContext = useContext(SMHeaderContext);
  return /*#__PURE__*/React.createElement(Button, {
    color: "upgrade",
    size: "sm",
    "data-sm-metrics": generateMetricsAttribute({
      data: {
        actionType: 'webplat_header_upgrade.button_press',
        actionFlow: smHeaderContext.actionFlow
      }
    }),
    href: createURL('/pricing/upgrade/', {
      ut_source: 'header_upgrade',
      ut_source3: 'webplat'
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.UPGRADE,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 7
    }
  }));
};
export var CreateButton = function CreateButton() {
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "Addon__CreateSurveyBtn",
    color: "alt",
    className: "wds-m-l-3",
    size: "sm",
    href: createURL('/create/', {
      ut_source: 'header'
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CREATE_SURVEY,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 75,
      columnNumber: 7
    }
  }));
};
export var CreateTeam = function CreateTeam() {
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "Addon__CreateTeamBtn",
    color: "upgrade",
    size: "sm",
    href: createURL('/billing/p2gupgrade/', {
      ut_source: 'header',
      ut_source3: 'webplat'
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.CREATE_TEAM,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 91,
      columnNumber: 7
    }
  }));
};
export var AddUsers = function AddUsers() {
  return /*#__PURE__*/React.createElement(Button, {
    "data-testid": "Addon__AddUsersBtn",
    color: "upgrade",
    size: "sm",
    href: createURL('/team/add/', {
      ut_source: 'header',
      ut_source3: 'webplat'
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(T, {
    desc: COPY.ADD_USERS,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 107,
      columnNumber: 7
    }
  }));
};
export var showLICTA = function showLICTA(data) {
  var user = data.user || {};
  var team = user.team;
  var teamMembership = user.teamMembership || {};
  var _ref = user.package || {},
    isAnnual = _ref.isAnnual;
  var canAddUsers = teamMembership.isAdmin && team && team.ssoState !== 'REQUIRED';
  var showSeatUpgradeButton = (user === null || user === void 0 ? void 0 : user.features.powerCasualEnabled) && teamMembership.memberType === 'CASUAL';
  if (showSeatUpgradeButton) {
    return /*#__PURE__*/React.createElement(SeatUpgradeButton, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 12
      }
    });
  }
  if (canAddUsers) {
    return /*#__PURE__*/React.createElement(AddUsers, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 127,
        columnNumber: 12
      }
    });
  }
  if (!team && isAnnual) {
    return /*#__PURE__*/React.createElement(CreateTeam, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 130,
        columnNumber: 12
      }
    });
  }
  if (!team) {
    return /*#__PURE__*/React.createElement(UpgradeButton, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 133,
        columnNumber: 12
      }
    });
  }
  return null;
};
export var Addon = function Addon(_ref2) {
  var addonLogInColor = _ref2.addonLogInColor,
    addonSignUpColor = _ref2.addonSignUpColor,
    addonSignUpVariant = _ref2.addonSignUpVariant,
    ctaRedirectUrl = _ref2.ctaRedirectUrl,
    isUserAuthenticated = _ref2.isUserAuthenticated,
    showLoginButton = _ref2.showLoginButton,
    showSignupButton = _ref2.showSignupButton,
    variant = _ref2.variant,
    joinTeamSlug = _ref2.joinTeamSlug,
    joinTeamAmplitudeProps = _ref2.joinTeamAmplitudeProps;
  var auth = isUserAuthenticated ? 'auth' : 'anon';
  return /*#__PURE__*/React.createElement(TabletScreen, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 152,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "Addon__Container",
    className: "sm-addon__".concat(auth, "--").concat(variant),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 153,
      columnNumber: 7
    }
  }, showLoginButton && /*#__PURE__*/React.createElement(LogInCTA, {
    variant: "text",
    color: addonLogInColor,
    params: _objectSpread({
      ut_source: 'megamenu'
    }, ctaRedirectUrl && {
      ep: ctaRedirectUrl
    }),
    className: "sm-addon__log-in sm-addon__log-in--".concat(addonLogInColor),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 158,
      columnNumber: 11
    }
  }), showSignupButton && /*#__PURE__*/React.createElement(SignUpCTA, {
    variant: addonSignUpVariant,
    color: addonSignUpColor,
    params: _objectSpread({
      ut_source: 'megamenu'
    }, ctaRedirectUrl && {
      ep: ctaRedirectUrl
    }),
    className: "sm-addon__sign-up sm-addon__sign-up--".concat(addonSignUpColor),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 169,
      columnNumber: 11
    }
  }), !!(joinTeamSlug !== null && joinTeamSlug !== void 0 && joinTeamSlug.length) && /*#__PURE__*/React.createElement("div", {
    className: "sm-addon__join-team-wrapper",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 180,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(JoinTeamCTA, {
    joinTeamSlug: joinTeamSlug,
    className: "sm-addon__join-team",
    amplitudeProps: joinTeamAmplitudeProps,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 181,
      columnNumber: 13
    }
  }))));
};
Addon.propTypes = {
  addonLogInColor: PropTypes.oneOf(['secondary', 'alt']),
  addonSignUpColor: PropTypes.oneOf(['upgrade', 'alt']),
  addonSignUpVariant: PropTypes.oneOf(['default', 'ghost']),
  ctaRedirectUrl: PropTypes.string,
  isUserAuthenticated: PropTypes.bool,
  showLoginButton: PropTypes.bool,
  showSignupButton: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'limited', 'slim']),
  joinTeamSlug: PropTypes.string,
  joinTeamAmplitudeProps: PropTypes.shape({
    pageName: PropTypes.string,
    guestId: PropTypes.number,
    surveyId: PropTypes.number,
    surveyOwnerId: PropTypes.number
  })
};
Addon.defaultProps = {
  addonLogInColor: 'alt',
  addonSignUpColor: 'alt',
  addonSignUpVariant: 'default',
  ctaRedirectUrl: '',
  isUserAuthenticated: false,
  showLoginButton: true,
  showSignupButton: true,
  variant: 'default',
  joinTeamSlug: undefined,
  joinTeamAmplitudeProps: {}
};
//# sourceMappingURL=index.js.map